import { Component } from '@angular/core';

@Component({
  selector: 'app-create-attendance',
  standalone: true,
  templateUrl: './create-attendance.component.html',
  styleUrl: './create-attendance.component.css',
})
export class CreateAttendanceComponent {}
